import VGCatalog from "../catalog/catalog";
import VGMenuAim from "../../../../../modules/vegas/js/menu-aim";
import {
	addClass,
	find,
	findID,
	isEmptyObj,
	removeClass
} from "../../../../../modules/vegas/js/util";
import axios from "axios";
import enableScrollbar from "./../../../ui/scrollbar/scrollbar"

class VGCatalogCategories extends VGCatalog {
	static tree = null;

	constructor(element, arg = {}) {
		super();

		if (!element) {
			console.error('Первый параметр не должен быть пустым');
			return false;
		} else {
			if (typeof element === 'string') {
				let $element = document.querySelector(element);
				if ($element) {
					this.element = $element;
				} else {
					console.error('В строке должен быть идентификатор боковой панели');
				}
			} else {
				this.element = element;
			}
		}
	}

	loadTree() {
		if (VGCatalogCategories.tree === null) {
			axios.get('/catalog/categories_tree').then(response => {
				VGCatalogCategories.tree = response.data.tree;
			})
		}
	}

	init() {
		let _this = this;
		_this.loadTree();

		// Уровни
		let $firstLevel  = find('.categories-wrapper-first', _this.element),
			$secondLevel = find('.categories-wrapper-second', _this.element),
			$thirdLevel  = find('.categories-wrapper-third',  _this.element);

		// Открыли каталог, скрыли уровни
		_this.toggle($secondLevel);
		_this.toggle($thirdLevel);

		// Активируем меню второго уровня
		let $menu = findID('list-categories');
		_this.menuAim($menu, activateSecondLevel, deactivateSecondLevel, exitSecondLevel);

		// Второй уровень
		function activateSecondLevel($row) {
			let submenuId = $row.dataset.id,
				id = parseInt($row.dataset.num),
				$submenu = document.getElementById(submenuId),
				$link = find('a', $row);

			addClass($link, 'active');

			$secondLevel.innerHTML = '';
			addClass($submenu,'show');

			let tree = _this.getData();

			tree.forEach(function (category) {
				if (category.id === id) {
					if ('children' in category && category.children.length) {
						_this.toggle($secondLevel, 'show');
						$firstLevel.classList.add('no-border-radius');
						_this.build(category.children, id, $secondLevel, category, function (ul) {
							_this.menuAim(ul, activateThirdLevel, deactivateThirdLevel, exitThirdLevel);
						});
					} else {
						_this.toggle($secondLevel, 'hide');
						_this.toggle($thirdLevel, 'hide');
						$firstLevel.classList.remove('no-border-radius');
					}
				}
			});
		}

		function deactivateSecondLevel(row) {
			let a = find('a', row);
			removeClass(a,'active');
			$secondLevel.classList.remove('no-border-radius');
			_this.toggle($thirdLevel, 'hide');
		}

		function exitSecondLevel() {
			/*_this.toggle($secondLevel);
			_this.toggle($thirdLevel);*/
		}

		// Третий уровень
		function activateThirdLevel($row) {
			let id = parseInt($row.dataset.id),
				$link = find('a', $row);

			addClass($link, 'active');
			removeClass($thirdLevel, 'show');

			if (id) {
				let categoryData = _this.getData(id);
				$thirdLevel.innerHTML = '';

				if ('children' in categoryData && categoryData.children.length) {
					_this.build(categoryData.children, id, $thirdLevel, categoryData);
					_this.toggle($thirdLevel, 'show');
					$secondLevel.classList.add('no-border-radius');
				}
			}
		}

		function deactivateThirdLevel(row) {
			let a = find('a', row);
			removeClass(a,'active');
			$secondLevel.classList.remove('no-border-radius');
		}

		function exitThirdLevel() {
			/*_this.toggle($secondLevel);
			_this.toggle($thirdLevel);*/
		}
	}

	toggle(el, stage = 'hide') {
		if (stage === 'show') {
			addClass(el,'show');
		}

		if (stage === 'hide') {
			removeClass(el, 'show');
		}
	}

	menuAim(element, activate, deactivate, exit) {
		new VGMenuAim(element, {activate, deactivate, exit});
	}

	getData(id = null, tree = {}) {
		const findItemNested = (arr, itemId, nestingKey) => (
			arr.reduce((a, item) => {
				if (a) return a;
				if (item.id === itemId) return item;
				if (item[nestingKey]) return findItemNested(item[nestingKey], itemId, nestingKey)
			}, null)
		);

		if (isEmptyObj(tree)) {
			tree = VGCatalogCategories.tree;
		}

		if (id) {
			return findItemNested(tree, id, 'children') || {};
		} else {
			return tree || {};
		}
	}

	build(categories, id, sub, parentCategory = null, callback) {
		let div = document.createElement('div');
		div.classList.add('categories-content');
		div.setAttribute('data-scrollbar', 'true');
		div.setAttribute('data-always-show-tracks', 'true');

		let ul = document.createElement('ul');
		ul.classList.add('list');
		ul.classList.add('list-column');
		ul.classList.add('list-categories');
		ul.setAttribute('id', 'sub-category-' + id);

		categories.forEach(function (category) {
			let li = document.createElement('li');

			li.classList.add('list-item');
			li.setAttribute('data-id', category.id)

			let a = document.createElement('a');
			a.setAttribute('href', category.url);

			let title = document.createElement('span');
			title.classList.add('title')
			title.innerText = category.title;
			a.append(title);

			if (category && 'children' in category && category.children.length) {
				let span = document.createElement('span');
				span.classList.add('toggle')
				span.innerHTML = '<i class="fa fa-chevron-right"></i>';
				a.append(span);

				a.setAttribute('href', '#');
			}

			li.append(a);
			ul.append(li);
		});

		if (parentCategory) {
			let parentLi = document.createElement('li');
			let parentLink = document.createElement('a');
			parentLink.setAttribute('href', parentCategory.url);
			parentLink.innerText = `Смотреть всё`;
			parentLi.classList.add('to-parent');
			parentLi.classList.add('list-item');
			parentLi.append(parentLink);
			ul.append(parentLi);
		}

		div.append(ul);
		sub.append(div);

		enableScrollbar(div);

		if (typeof callback === "function") {
			callback(ul)
		}
	}
}

export default VGCatalogCategories;
